import React from 'react'
import Todo from './Todo'
// import { __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED } from 'react-dom'

const AllTodos = ({allTodos, setAllTodos, filteredTodos}) => {
// console.log(allTodos)
    const todolist = filteredTodos.map(item => {
        return (
            <div className='todo scroll'>
                <Todo
                    todo={item}
                    allTodos={allTodos}
                    setAllTodos={setAllTodos}
                    key={item.id} />
                    
            </div>
            
        )
    })


    return(
        <div className='all-todos'>
           <ul>
               {todolist}
           </ul>
        </div>
        
    )
}

export default AllTodos